// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CloseButton[data-v-6a4a56d1]{margin:.4rem 0;display:inline-block}@media only screen and (max-width:1023px){.CloseButton[data-v-6a4a56d1]{padding:1.375rem 1.75rem}}", ""]);
// Exports
module.exports = exports;
